module.exports = __webpack_public_path__ + "static/media/Download.d6249546.svg";